













































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Cell, Checkbox, CheckboxGroup, Button, Field } from "vant";
import CustomSelect from "../components/CustomSelect.vue";

const createAccountModule = namespace("createAccount");

@Component({
  name: "SurveyPageTwo",
  components: {
    [Cell.name]: Cell,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    customSelect: CustomSelect,
    [Button.name]: Button,
    [Field.name]: Field
  }
})
export default class SurveyPageTwo extends Vue {
  @createAccountModule.Getter("examine_list") examine_list: any;
  @createAccountModule.Mutation("SAVE_EXAMINE_LIST")
  saveExamineList: any;

  investmentExp: any = [];

  @Watch("examine_list", { deep: true, immediate: true })
  watchExamineList(val) {
    
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get allowOpenAccount() {
    // const { derivative } = this.examine_list;
    // //条件1：衍生品认知是否了解 true：了解 false: 不了解
    // const cond1 = derivative && derivative[0].value !== 1;
    // //条件2：投资经验任意一项有经验 true：任意一项有经验 false:都没有经验
    // const cond2 = this.investmentExp[2].value !== 1;
    return false;
  }

  get isSubmitDisabled() {
    const res = this.investmentExp.some(item => {
      if (item.value) {
        if (item.showInput && !item.inputValue) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    });
    return res;
  }

  created() {
    this.investmentExp = this.$t(
      "open_account.survey.page_two.investment_exp_list"
    );
  }

  handleChange(option, item) {
    if (item.inputValue !== undefined) {
      if (option.value !== 1) {
        item.showInput = true;
      } else {
        item.showInput = false;
        item.inputValue = "";
      }
    }
  }

  handleNextStep() {
    
    const arr = this.investmentExp.map(item => {
      return item.value;
    });
    
    const obj: any = window.localStorage.getItem("accountOpenObject");
    const newObj = Object.assign(JSON.parse(obj), { pageTwo: arr });
    window.localStorage.setItem("accountOpenObject", JSON.stringify(newObj));
    this.saveExamineList({ investmentExp: this.investmentExp });
    this.$router.push("/survey/page-three");
  }
}
